var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import 'rxjs/add/observable/fromPromise';
import { Headers, Http } from '@angular/http';
import { AuthenticationService, Logger } from 'app/core/index';
import { map } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
var log = new Logger('WithdrawService');
var WithdrawService = /** @class */ (function () {
    function WithdrawService(http, auth) {
        this.http = http;
        this.auth = auth;
        this._updating = false;
        this._updated = false;
        this.limits = null;
        this.withdrawRequestedSubject = new BehaviorSubject(false);
        this.withdrawRequested$ = this.withdrawRequestedSubject.asObservable();
        log.debug('service constructed.');
    }
    WithdrawService.prototype.withdrawLimits = function (currency) {
        var headers = new Headers();
        headers.append('Authorization', this.auth.credentials.accessToken);
        return this.http
            .get("/api/withdraw/limit/" + currency, { headers: headers })
            .pipe(map(function (response) { return response.json(); }));
    };
    /**
     * @deprecated
     */
    WithdrawService.prototype.getLimits = function () {
        var _this = this;
        if (this._updating) {
            return Promise.resolve(null);
        }
        this._updating = true;
        log.info('retrieving withdraw limits.');
        var headers = new Headers();
        headers.append('Authorization', this.auth.credentials.accessToken);
        return this.http
            .get('/api/withdraw/limits', { headers: headers })
            .toPromise()
            .then(function (response) {
            _this._updated = true;
            _this._updating = false;
            var value = response.json();
            _this.limits = value;
            log.debug('withdraw limits retrieved.', value);
            return _this.limits;
        })
            .catch(function (error) {
            _this._updating = false;
            _this._updated = false;
            log.error(error);
            return error;
        });
    };
    /**
     * Requests withdrawal
     * @returns {Promise<Response>}
     * @param body
     */
    WithdrawService.prototype.requestWithdraw = function (body) {
        var _this = this;
        log.info('withdraw requested.');
        var headers = new Headers();
        headers.append('Authorization', this.auth.credentials.accessToken);
        return this.http
            .post('/api/withdraw', body, {
            headers: headers,
        })
            .toPromise()
            .then(function (data) {
            log.debug('withdraw request finished with data: ', data);
            _this.withdrawRequestedSubject.next(true);
            return data;
        });
    };
    /**
     * Gets converted amount to a specified currency.
     * @param {string} from
     * @param {string} to
     * @param {number} amount
     * @returns {Promise<Error | never | Response>}
     */
    WithdrawService.prototype.getConvertedAmount = function (from, to, amount) {
        log.info('retrieving converted amount');
        var headers = new Headers();
        headers.append('Authorization', this.auth.credentials.accessToken);
        return this.http.get("/api/withdraw/convert-amount?from=" + from + "&to=" + to + "&amount=" + amount, { headers: headers }).pipe(map(function (response) {
            return __assign({}, response.json(), { fromAmount: amount });
        }));
    };
    WithdrawService.prototype.getFullCurrencies = function () {
        var headers = new Headers();
        headers.append('Authorization', this.auth.credentials.accessToken);
        return this.http.get("/api/withdraw/currencies-full", { headers: headers }).pipe(map(function (response) {
            return response.json().filter(function (currency) { return !!currency.enabled; });
        }));
    };
    /**
     * Gets currency exchange limits.
     * @param {string} from
     * @param {string} to
     * @returns {Observable<any>}
     */
    WithdrawService.prototype.getCurrencyLimit = function (from, to) {
        log.info('retrieving converted amount');
        var headers = new Headers();
        headers.append('Authorization', this.auth.credentials.accessToken);
        return this.http.get("/api/withdraw/currency-limits?from=" + from + "&to=" + to, { headers: headers }).pipe(map(function (response) {
            return response.json();
        }));
    };
    /**
     * @param requestId
     * @param code
     */
    WithdrawService.prototype.getWithdrawalRequest = function (requestId, code) {
        return this.http
            .get("/api/withdraw/request?requestId=" + requestId + "&confirmationCode=" + code)
            .pipe(map(function (response) { return response.json(); }));
    };
    /**
     * @param requestId
     * @param code
     * @param state
     */
    WithdrawService.prototype.confirmWithdrawalRequest = function (requestId, code, state) {
        return this.http
            .patch("/api/withdraw/request", {
            confirmationCode: code,
            requestId: requestId,
            state: state,
        })
            .pipe(map(function (response) { return response.json(); }));
    };
    return WithdrawService;
}());
export { WithdrawService };



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/core/account/withdraw.service.ts.pre-build-optimizer.js